export const ifWindow = (callback) => {
  if (typeof window !== 'undefined') {
    return callback();
  }
};
export const onClient = () => typeof window !== 'undefined';
